import { useHeaderContractWarnings } from "./hooks/useHeaderContractWarnings";
import { HeaderContractLinkBadge } from "./HeaderContractLinkBadge";

const FREE_PLAN_TOOLTIP =
  "Você está no plano gratuito. Para aumentar limites e liberar recursos adicionais, faça um upgrade do plano.";

export function HeaderContractWarnings() {
  const {
    isFreePlan,
    shouldShowTrialWarning,
    trialWarningTooltip,
    trialWarningLabel,
  } = useHeaderContractWarnings();

  return (
    <>
      {isFreePlan ? (
        <HeaderContractLinkBadge
          tooltip={FREE_PLAN_TOOLTIP}
          label="Plano gratuito"
        />
      ) : null}

      {shouldShowTrialWarning ? (
        <HeaderContractLinkBadge
          tooltip={trialWarningTooltip}
          label={trialWarningLabel}
        />
      ) : null}
    </>
  );
}
